import {
  Handshake,
  Contact,
  Database,
  ChartLine,
  Building2,
  Map,
  ListChecks,
  Palette,
  LogOut,
  User,
  Plus,
  ArrowRightLeft,
  Megaphone,
  Bell,
  Users,
  Settings,
  ChevronDown,
  Bot,
  Pencil,
  Trash2,
  GripVertical,
  LayoutDashboard,
  UserCheck,
  Columns3Cog,
} from 'lucide-angular';

export const AppIcons = {
  Handshake,
  Contact,
  Database,
  ChartLine,
  Building2,
  Map,
  ListChecks,
  Palette,
  LogOut,
  User,
  Plus,
  ArrowRightLeft,
  Megaphone,
  Bell,
  Settings,
  Users,
  ChevronDown,
  Bot,
  Pencil,
  Trash2,
  GripVertical,
  LayoutDashboard,
  UserCheck,
  Columns3Cog,
};
